<ul *ngIf="rolesForUserApp.length > 0; else noRolesTemplate">
  <li *ngFor="let role of rolesForUserApp" class="roles-list">
    <p-checkbox
    name="activeRolesForUserApp"
    [value]="role.id"
    [(ngModel)]="activeRolesForUserApp"
    (onChange)="manageRoles($event, role.id)"
    [label]="role.description">
    </p-checkbox>
  </li>
</ul>

<ng-template #noRolesTemplate>
  <p>No Roles Found</p>
</ng-template>



// WEBPACK FOOTER //
// ./src/app/views/administration/company-admin/user-app-role-management/user-app-role-management.component.html